module.exports = __webpack_public_path__ + "static/media/SideMenu_Invoices.18fc507b.svg";